<template>
    <v-card class="ma-4 px-4" style="height: calc(100% - 36px);" outlined :loading="loading">
        <v-row>
            <v-col cols="9">
                <v-text-field v-model="article.Title" label="Title" prepend-icon="mdi-feather" />
                <v-text-field v-model="article.Url" label="Friend URL" dense prepend-icon="mdi-link-variant" />
                <v-textarea v-model="article.Description" label="Description" rows="2" dense prepend-icon="mdi-comma"></v-textarea>
                <v-combobox
                    v-model="article.Tags"
                    :items="tags"
                    :search-input.sync="tagInput"
                    hide-selected
                    height="40"
                    hint="Maximum of 5 tags"
                    label="Tags"
                    dense
                    multiple
                    persistent-hint
                    prepend-icon="mdi-tag"
                >
                    <template v-slot:selection="data">
                        <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                        >
                            <v-avatar class="primary white--text" left v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>
                            {{ data.item }}
                        </v-chip>
                    </template>
                </v-combobox>
            </v-col>
            <v-col cols="3">
                <img-upload v-model="article.Img"></img-upload>
            </v-col>
        </v-row>
        <mavon-editor
            style="height: calc(100vh - 500px);"
            ref="md"
            v-model="article.Markdown"
            @imgAdd="imgAdd"
            codeStyle="obsidian"
            defaultOpen="preview"
            :subfield="true"
            :editable="true"
            :tabSize="4"
            :toolbars="toolbarOptions"
        />
        <v-row class="d-flex justify-end mr-1">
            <v-btn class="mt-4 mr-4 grey" dark @click="saveArticle(0)"><v-icon left>mdi-content-save</v-icon>Save & Hide</v-btn>
            <v-btn class="mt-4" color="primary" @click="saveArticle(1)"><v-icon left>mdi-share</v-icon>Publish</v-btn>
        </v-row>
    </v-card>
</template>

<script>
import { apiGetArticle, apiSaveArticle } from "../../api/article";
import { getQiniuToken, uploadQiniu } from "../../api/qiniu";
import { Log } from "../../utils/debug";
import ImgUpload from "../../components/ImgUpload";

export default {
    name: "Article",
    components: { ImgUpload },
    data: () => ({
        loading: false,
        tags: ["Java", "C/C++", "Golang", "QT"],
        tagInput: "",
        article: {
            IDStr: "",
            Title: "",
            Description: "",
            Markdown: ``,
            Img: "",
            Url: "",
            Tags: []
        },
        toolbarOptions: {
            table: true,
            help: true,
            imagelink: true,
            navigation: true,
            superscript: true, // 上角标
            subscript: true, // 下角标
            htmlcode: true
        }
    }),
    mounted() {
        /* vue get the url params: */
        let urlIDStr = this.$route.params.id;
        Log.debug("id", urlIDStr);

        if (typeof urlIDStr != "undefined") {
            this.loading = true;
            apiGetArticle(urlIDStr).then(resp => {
                Log.debug(resp);
                Object.assign(this.article, resp.data);
                this.loading = false;
            });
        }
    },
    methods: {
        imgAdd(pos, file) {
            getQiniuToken().then(res => {
                let token = res.data;
                let formData = new FormData();
                formData.append("file", file);
                formData.append("token", token);
                uploadQiniu(formData).then(res => {
                    this.$refs.md.$img2Url(pos, "https://files.hexcode.cn/" + res.data.hash);
                });
            });
        },
        saveArticle(state) {
            this.article.State = state;
            apiSaveArticle(this.article).then(() => {
                this.$store.commit("muNotice", {
                    type: "success",
                    msg: "Article Save Successfully.",
                    timeout: 2000
                });
                if (state === 1) this.$router.push("/admin/article-list");
            });
        }
    }
};
</script>

<style></style>
